/**
 * Authentication utilities for Orgo SDK
 */

export function getApiKey(apiKey?: string): string {
  // Safe environment variable access
  let envApiKey: string | undefined;
  
  // Check if we're in Node.js environment
  if (typeof process !== 'undefined' && process.env) {
    envApiKey = (process as any).env.ORGO_API_KEY;
  }
  // Check if we're in browser environment with global variable
  else if (typeof window !== 'undefined' && (window as any).ORGO_API_KEY) {
    envApiKey = (window as any).ORGO_API_KEY;
  }
  
  const key = apiKey || envApiKey;
  
  if (!key) {
    throw new Error(
      'API key required. Set ORGO_API_KEY environment variable or pass apiKey parameter. ' +
      'Get a key at https://www.orgo.ai/start'
    );
  }
  
  return key;
}